var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.2a2.7 2.7 0 1 0-2.68-2.366L6.374 7.057a2.7 2.7 0 1 0 0 3.887l4.446 2.223a2.7 2.7 0 1 0 .805-1.61L7.18 9.334a2.726 2.726 0 0 0 0-.668l4.446-2.223A2.691 2.691 0 0 0 13.5 7.2z",
    fill: "#4318ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.decc6c40b9551cda001e087aae9c42e6.svg";
export { ForwardRef as ReactComponent };